// extracted by mini-css-extract-plugin
export default {"container":"K0-z","heading":"L0-z","links":"M0-z","copy":"N0-z","subCopy":"O0-z","linksLeft":"P0-z","linksCenter":"Q0-z","linksRight":"R0-z","link":"S0-z","onlyLink":"T0-z"};